<div class="container-fluid" class="my-3 mx-5">
    <div class="row ">
        <div class="col-12">
            <div class="alert alert-success" role="alert">
                <h4 class="alert-heading">Well done! Onboarding is successfull</h4>
                <p>Thanks for onboarding.</p>
                <hr>
                <p class="mb-0">You will receive an email on {{userService.onboarding.officialEMail}} with a verification link. Please verify you email by clicking on that link.</p>
              </div>
        </div>
    </div>
    
    </div>
    